import React, { useEffect, useState } from "react";
import {
  Container,
  Card,
  Button,
  Row,
  Col,
  Pagination,
  Badge,
  Modal,
  Carousel,
} from "react-bootstrap";
import { FiTrash2, FiPlus, FiSearch } from "react-icons/fi";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-hot-toast";

import { getActivity, deleteActivity } from "../../store/slices/activity";
import { getSubjectTeacher } from "../../store/slices/subjectteacher";

export default function StudentActivity() {
  const dispatch = useDispatch();

 
  const activeStudent = useSelector(
    (state) => state.activestudent?.student
  );

  const [data, setData] = useState([]);
  const [subjectMap, setSubjectMap] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [search, setSearch] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 25;

  const [showModal, setShowModal] = useState(false);
  const [activeItem, setActiveItem] = useState(null);

  /* >>>>>>>> Fetch Activity ------------------ */
  const fetchActivity = (students) => {
    if (!students) return;

    setIsLoading(true);

 
    dispatch(getActivity({ students }))
      .unwrap()
      .then((res) => setData(res?.data || []))
      .catch(() => {
        toast.error("Failed to fetch activities");
        setData([]);
      })
      .finally(() => setIsLoading(false));
  };

  /* ------------------ Fetch Subject Teacher (unchanged) <<<<<<<<<<<<<<<<< */
  const fetchSubjectTeacher = () => {
    dispatch(getSubjectTeacher())
      .unwrap()
      .then((res) => {
        const map = {};
        res?.data?.forEach((item) => {
          map[item.teacherId] = {
            standard: item.standardId?.name,
            section: item.sectionId?.name,
          };
        });
        setSubjectMap(map);
      })
      .catch(() => toast.error("Failed to fetch class info"));
  };

  /* ---------- Initial Load / Student Change ---------- */
  useEffect(() => {
    const studentId = activeStudent?._id;
    if (!studentId) return;

    fetchActivity(studentId);
    fetchSubjectTeacher();
    setCurrentPage(1);
  }, [activeStudent?._id]);

  /* >>>>>>>>>>>>>>>>>  Delete ------------------ */
  const handleDelete = (id) => {
    if (!window.confirm("Delete this activity?")) return;

    dispatch(deleteActivity(id))
      .unwrap()
      .then(() => {
        toast.success("Activity deleted");
        fetchActivity(activeStudent?._id);
      })
      .catch((error) => {
        console.log(error);
        toast.error("delted activity failed");
      });
  };

  /* ------------------ Filter , Pagination >>>>>>>>>>>>>>>> */
  const filteredData = data.filter((item) =>
    item.title?.toLowerCase().includes(search.toLowerCase())
  );

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedData = filteredData.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  return (
    <Container fluid className="px-3 px-md-3">
      {/* Header */}
      <div className="staff-header mb-4">
        <div className="staff-breadcrumb">
          <Link to="/teacher/home" className="crumb home">
            Home
          </Link>
          <span className="crumb current">Activity Overview</span>
        </div>

        {/* <div className="staff-header-right">
          <Link to="/teacher/add-activity" className="btn-submit">
            <FiPlus /> Add Activity
          </Link>
        </div> */}
      </div>

      <div
        style={{
          backgroundColor: "#ffffff",
          borderRadius: "20px",
          padding: "20px",
          boxShadow: "0 8px 24px rgba(0,0,0,0.06)",
        }}
      >
        {/* Search */}
        <Row className="align-items-center mb-4">
          <Col xs={12} md={4}>
            <div className="staff-search">
              <FiSearch />
              <input
                placeholder="Search activity title"
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </Col>
        </Row>

        {/* Cards */}
        <Row>
          {isLoading ? (
            <Col xs={12} className="text-center py-5">
              Loading activities...
            </Col>
          ) : paginatedData.length ? (
            paginatedData.map((item) => {
              const cls = subjectMap[item.teacherId] || {};
              return (
                <Col
                  key={item._id}
                  sm={6}
                  md={4}
                  lg={3}
                  xl={3}
                  className="mb-4"
                >
                  <Card
                    className="border-0 shadow-sm h-100"
                    style={{
                      borderRadius: "16px",
                      cursor: "pointer",
                      position: "relative",
                    }}
                    onClick={() => {
                      setActiveItem(item);
                      setShowModal(true);
                    }}
                  >
                    {/* Date */}
                    <small
                      style={{
                        position: "absolute",
                        top: "10px",
                        left: "10px",
                        backgroundColor: "#efeef3",
                        color: "#6f42c1",
                        zIndex: 2,
                        fontSize: "10px",
                        padding: "5px",
                        borderRadius: "5px",
                        fontWeight: "bold",
                      }}
                    >
                      {new Date(item.date).toLocaleDateString("en-GB")}
                    </small>

                    {/* Image */}
                    <Card.Img
                      src={item.files?.[0]}
                      alt="activity"
                      style={{
                        height: "150px",
                        objectFit: "cover",
                        borderTopLeftRadius: "16px",
                        borderTopRightRadius: "16px",
                      }}
                    />

                    <Card.Body className="p-3">
                      <h6 className="fw-semibold text-truncate mb-2">
                        {item.title}
                      </h6>

                      <div className="d-flex align-items-center">
                        <small
                          style={{
                            color: "#111111",
                            marginRight: "6px",
                            fontSize: "16px",
                          }}
                        >
                          {cls.standard || "Std"}
                        </small>

                        <small style={{ color: "#0c0c0c", fontSize: "15px" }}>
                          - {cls.section || "Sec"} Sec
                        </small>

                        <FiTrash2
                          className="ms-auto text-danger"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDelete(item._id);
                          }}
                          style={{ cursor: "pointer" }}
                        />
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              );
            })
          ) : (
            <Col xs={12} className="text-center py-5">
              No activities found
            </Col>
          )}
        </Row>

        {/* Pagination */}
        {filteredData.length > 0 && (
          <div className="d-flex justify-content-end mt-3">
            <Pagination>
              <Button
                disabled={currentPage === 1}
                onClick={() => setCurrentPage((p) => p - 1)}
                style={{
                  background: "transparent",
                  color: "#8451ff",
                  borderRadius: "15px",
                }}
              >
                <IoIosArrowBack />
              </Button>

              <Button active disabled style={{ borderRadius: "20px" }}>
                {currentPage}
              </Button>

              <Button
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage((p) => p + 1)}
                style={{
                  background: "transparent",
                  color: "#8451ff",
                  borderRadius: "15px",
                }}
              >
                <IoIosArrowForward />
              </Button>
            </Pagination>
          </div>
        )}
      </div>

      {/* Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Activity Details</Modal.Title>
        </Modal.Header>

        <Modal.Body className="text-center">
          {activeItem && (
            <>
              <Carousel
                indicators={activeItem.files?.length > 1}
                prevIcon={
                  <span style={{ color: "black", fontSize: "28px" }}>‹</span>
                }
                nextIcon={
                  <span style={{ color: "black", fontSize: "28px" }}>›</span>
                }
              >
                {activeItem.files?.map((img, i) => (
                  <Carousel.Item key={i}>
                    <img
                      src={img}
                      alt="activity"
                      style={{
                        width: "200px",
                        height: "200px",
                        objectFit: "cover",
                        borderRadius: "12px",
                        margin: "0 auto",
                      }}
                    />
                  </Carousel.Item>
                ))}
              </Carousel>

              <h5 className="mt-3">{activeItem.title}</h5>
              <p className="text-muted mb-2">
                {new Date(activeItem.date).toLocaleDateString("en-GB")}
              </p>

              <div className="d-flex justify-content-center gap-2">
                <Badge style={{ backgroundColor: "#6f42c1", color: "#fff" }}>
                  {subjectMap[activeItem.teacherId]?.standard}
                </Badge>
                <Badge style={{ backgroundColor: "#6f42c1", color: "#fff" }}>
                  {subjectMap[activeItem.teacherId]?.section}
                </Badge>
              </div>
            </>
          )}
        </Modal.Body>
      </Modal>
    </Container>
  );
}
